import React from "react";
import { Button, Modal } from "react-bootstrap";
import moment from "moment";
import { KEY_LABELS } from "../constants/visitDataAccordian";

const ActionsModal = ({
  showModal,
  handleToggleModal,
  selectedDevice,
  otpDataError,
  otpData,
}) => {
  return (
    <Modal show={!!showModal} onHide={handleToggleModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          {showModal === "action" ? (
            <span>Actions for {selectedDevice?.teacherMobile}</span>
          ) : (
            <span>OTP for {selectedDevice?.teacherMobile}</span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showModal === "action" ? (
          <ul>
            {selectedDevice?.actions?.map((action, index) => (
              <li key={`action-${index}`}>{action}</li>
            ))}
          </ul>
        ) : (
          <div className="otp-modal-body-container">
            {!otpDataError && otpData?.otpCode ? (
              <>
                <div>
                  {otpData?.otpCode
                    .toString()
                    ?.split("")
                    ?.map((num) => {
                      return <span className="badge otp-badge">{num}</span>;
                    })}
                </div>
                <div className="item">
                  <strong>{KEY_LABELS.otpExpiredTime}</strong>
                  <span>
                    {otpData?.expiredTime
                      ? moment(otpData?.expiredTime).format(
                          " DD-MM-YYYY hh:MM A"
                        )
                      : ""}
                  </span>
                </div>
                <div className="item">
                  <strong>{KEY_LABELS.attempts} </strong>
                  <span> {otpData?.otpCode ? otpData?.attempts : ""}</span>
                </div>
              </>
            ) : (
              <>{otpDataError}</>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleToggleModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ActionsModal;
